import React from "react";

export const AppContext = React.createContext({
  showOverlayLoader: () => {},
  hideOverlayLoader: () => {},
  hidePagePreloader: () => {},
  showPagePreloader: () => {},

  setTranslations: () => {},
  refreshPage: () => {},
  translations: null
});
